import qs from "qs";
import FycLinkCTAButtonProps from "./SanityFycLinkCTA";
import { isPresent } from "src/utils/checks";
import { generateRange, getMonth } from "components/MonthCalendar/utils";
import { AlgoliaFacets, AlgoliaURLFacets } from "types/algolia";
import { Language } from "src/utils/localization/languages/types";

export const buildFycLinkCTAUrl = (
  props: Omit<FycLinkCTAButtonProps, "variant" | "label">,
  language: Language
) => {
  const refinementList: Partial<Record<keyof AlgoliaURLFacets, string[]>> = {
    destinationNames:
      props.filterByDestination
        ?.map((d) => d?.name?.localized)
        .filter(isPresent) || [],
    promoCodes:
      props.filterByOffer
        ?.map((o) => o?.configuration?.code)
        .filter(isPresent) || [],
    dayGroup: props.filterByDurations?.filter(isPresent) || [],
    "content.shipName":
      props.filterByShip?.map((s) => s?.name).filter(isPresent) || [],
    countryNames:
      props.filterByCountries
        ?.map((c) => c?.name?.localized)
        .filter(isPresent) || [],
    portNames:
      props.filterByPorts
        ?.map((p) => p?.name?.localized || p?.data?.name?.localized)
        .filter(isPresent) || [],
    features: props.filterByFeatures?.filter(isPresent) || [],
    departureYearMonth:
      props.filterByDepartureYears
        ?.filter(isPresent)
        .flatMap(buildDepartureYear) || [],
    [`cruiseTagsTree.${language.sanityCode}.level0`]:
      props.filterByCruiseTagCategories
        ?.map((cat) => cat?.title?.localized)
        .filter(isPresent) || []
  };

  const params = qs.stringify({ refinementList });
  return `${props.defaultFYCPath || "#"}?${params}`;
};

const buildDepartureYear = (year: string) => {
  return generateRange(12).map((monthIndex) => {
    return getMonth(parseInt(year, 10), monthIndex);
  });
};
